import { StyleStatus, ModelNumber, StyleFormData } from './types';

/**
 * 查询键常量
 */
export const QUERY_KEYS = {
  STYLE_LIST: 'style-list',
  STYLE_DETAIL: 'style-detail',
  MODEL_OPTIONS: 'model-options',
  STYLE_TYPE_OPTIONS: 'style-type-options',
} as const;

/**
 * 抽屉配置
 */
export const DRAWER_CONFIG = {
  WIDTH: 800,
  PLACEMENT: 'right' as const,
} as const;

/**
 * 表单默认值
 */
export const FORM_DEFAULT_VALUES: Partial<StyleFormData> = {
  status: StyleStatus.ENABLED,
  limitTime: 0,
  isSelfStyle: 0,
  defaultSelected: 0,
  isRecommend: 0,
  isVipStyle: 0,
  // freeUse: 0,
  // styleOrder, recommendSort, gcoins, pcoins 不设置默认值，允许为空
} as const;

/**
 * 上传图片配置
 */
export const UPLOAD_IMAGE_SIZE = 400;

/**
 * 表格配置
 */
export const TABLE_CONFIG = {
  ICON_SIZE: 60,
  PAGE_SIZE_OPTIONS: ['10', '20', '50', '100'] as (string | number)[],
};

/**
 * 模型编号映射
 */
export const MODEL_NUMBER_MAP: Record<ModelNumber, string> = {
  [ModelNumber.MODEL_1_0]: '1.0',
  [ModelNumber.MODEL_X]: 'x',
  [ModelNumber.MODEL_3_0]: '3.0',
};

/**
 * 状态映射
 */
export const STATUS_MAP: Record<StyleStatus, { text: string; color: string }> = {
  [StyleStatus.DISABLED]: { text: '失效', color: 'default' },
  [StyleStatus.ENABLED]: { text: '生效', color: 'success' },
};

